<template>
  <generic-link
    :class="{ 'nav-link': !inDropdown }"
    href="#"
    title="Logout"
    data-cy="logout-link"
    @click.native.prevent="logout"
  >
    <login-svg-icons
      v-if="!inDropdown"
      name="LogOutIcon"
    />
    <span :class="{ 'nav-label': !inDropdown }">
      Logout
    </span>
  </generic-link>
</template>

<script>
import LoginSvgIcons from './login-svg-icons'

export default {
  name: 'user-logout',
  components: {
    LoginSvgIcons
  },
  props: {
    inDropdown: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    logout: function() {
      this.$eventHub.$emit('logout')
    }
  }
}
</script>
